module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/92.3b43c7bb.png";